import { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import Screen from "../../../components/Screen";
import { useKiosk } from "../../../hooks/useKiosk";
import { useKioskInactivity } from "../../../hooks/useKioskInactivity";
import './LoginKiosk.css';
import { useNavigate } from "react-router-dom";
import { HotelContext } from "../../../context/hotel";
import { getCDNImage } from "../../../globals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { T, TF } from "react-translator-component";
import { isGemunder } from "../../../components/CheckIn/hotelConditions";

const LoginKiosk = () => {

    const navigate = useNavigate();
    const { data: hotel } = useContext(HotelContext);
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const { loginKiosk, isKioskLoggedIn } = useKiosk();
    const { setInactivityTimeoutMs } = useKioskInactivity();

    useEffect(() => {
        if (isKioskLoggedIn) {
            navigate(`/${hotel?.code}/checkin/identify`);
        }
    }, [isKioskLoggedIn, navigate, hotel?.code, setInactivityTimeoutMs]);

    const handleLoginKiosk = async () => {
        if (!password.trim()) {
            setError(T('kiosk.login.error_empty'));
            return;
        }

        setIsLoading(true);
        setError('');
        
        try {
            const response = await loginKiosk(password);
            if (response?.valid == true) {
                navigate(`/${hotel?.code}/checkin/identify`);
            } else {
                setError(T('kiosk.login.error_invalid'));
                setPassword('');
            }
        } catch (err) {
            setError(T('kiosk.login.error_process'));
            setPassword('');
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLoginKiosk();
        }
    };

    return (
        <Screen
            section={'kiosk-login'}
            title={'Login Kiosk'}
            buttonBack={false}
            showBackButton={false}
            hideHeader={true}
        >
            <div className={`kiosk-login-container ${hotel?.code}`}>
                {/* Background Gradient */}
              {/* {!isGemunder(hotel?.id) && <div className="kiosk-login-background"></div>} */}

                {/* Content */}
                <div className="kiosk-login-content">
                    {/* Hotel Branding */}
                 

                    {/* Login Form */}
                    <div className="kiosk-login-form-wrapper">
                        
                    <div className="kiosk-login-branding">
                        {hotel?.logo && (
                            <img 
                                src={getCDNImage(hotel.logo)} 
                                alt={hotel?.name || 'Hotel Logo'} 
                                className="kiosk-login-logo"
                            />
                        )}
                        <div className="kiosk-login-hotel-info">
                            <h1 className="kiosk-login-hotel-name">{hotel?.name || 'Hotel'}</h1>
                        </div>
                    </div>
                    <div className="separator"></div>
                    <div className="kiosk-login-icon-wrapper-container">
                        <div className="kiosk-login-icon-wrapper">
                            <FontAwesomeIcon icon={faLock} className="kiosk-login-icon" />
                        </div>
                        <h2 className="kiosk-login-title">{T('kiosk.login.title')}</h2>
                    </div>
                        <p className="kiosk-login-description">
                            {T('kiosk.login.description')}
                        </p>

                        {/* Password Input */}
                        <div className="kiosk-login-input-group">
                            <Form.Control
                                type={'password'}
                                maxLength={4}
                                value={password}
                                disabled={isLoading}
                                placeholder="••••"
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setError('');
                                }}
                                minLength={4}
                                onKeyPress={handleKeyPress}
                                className={'kiosk-login-input'}
                                autoFocus
                            />
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="kiosk-login-error">
                                {error}
                            </div>
                        )}

                        {/* Submit Button */}
                        <Button
                            className={'kiosk-login-button'}
                            disabled={isLoading || !password.trim()}
                            onClick={handleLoginKiosk}
                        >
                            {isLoading ? T('kiosk.login.button_loading') : T('kiosk.login.button_access')}
                        </Button>
                    </div>

                    {/* Footer */}
                    {/* <div className="kiosk-login-footer">
                        <p>{TF('kiosk.login.copyright', {year: new Date().getFullYear(), hotel: hotel?.name })}</p>
                    </div> */}
                </div>
            </div>
        </Screen>
    );
};

export default LoginKiosk;